import React from 'react';
import { CategoryHero } from 'shared/CategoryHero';
import { CategoryPage } from 'shared/CategoryPage';
import { Locations } from 'shared/Locations';
import { HomeSchedule } from 'views/Home/HomeSchedule';
import { Banner } from 'components/Banner';
import withScrollToTop from 'hocs/withScrollToTop';
import { useQuery } from '@apollo/client';
import { GET_CATEGORY_A_PAGE } from 'services/graphql/pages/category';
import { GET_FILTERED_RECORDS } from 'services/graphql/records';

const CategoryA = () => {
  const { loading, error, data } = useQuery(GET_CATEGORY_A_PAGE);
  const {
    loading: loadingRecords,
    error: errorRecords,
    data: dataRecords,
  } = useQuery(GET_FILTERED_RECORDS, {
    variables: { activeCategory: 'A' },
  });

  return (
    <main className="category category-a">
      <CategoryHero
        category="A"
        isLoading={loading}
        formTitle={
          <p>
            Запись <br /> на категорию А
          </p>
        }
        blockColor="green"
        image={
          !loading && !error
            ? data?.categoryAPage?.data?.attributes?.content.image
            : null
        }
        image_mobile={
          !loading && !error
            ? data?.categoryAPage?.data?.attributes?.content.image_mobile
            : null
        }
        onAsyncFunc={() => setTimeout(() => alert('Success'), 200)}
      />
      <CategoryPage
        content={
          !loading && !error
            ? data?.categoryAPage?.data?.attributes?.content
            : {}
        }
      />
      <HomeSchedule
        items={
          !loadingRecords && !errorRecords ? dataRecords?.records?.data : []
        }
      />
      {data?.categoryAPage?.data?.attributes?.banner !== null && (
        <div className="container banner__container">
          <Banner
            bgColor="green"
            content={data?.categoryAPage?.data?.attributes?.banner}
          />
        </div>
      )}
      <Locations />
    </main>
  );
};

export default withScrollToTop(CategoryA);
